import { FETCH_SUGGESTIONS } from './constants'

export const fetchSuggestions = {
  request: query => ({ type: FETCH_SUGGESTIONS.REQUEST, query }),
  success: results => ({ type: FETCH_SUGGESTIONS.SUCCESS, results })
}



// WEBPACK FOOTER //
// ./src/containers/ESSearch/actions.js